__webpack_require__.p = "/statistics/";